import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import MeansOfSupport from '../../MeansOfSupport/MeansOfSupport';
import { Body, H7, Stack } from '@qred/components-library';

const ApiFailureError = () => {
  const translate = useTranslate();

  return (
    <Stack>
      <Stack align="center">
        <H7>{translate('ApiFailureError.ErrorMessageTitle')}</H7>
        <Body size="lg">{translate('ApiFailureError.ErrorMessageText')}</Body>
      </Stack>
      <MeansOfSupport />
    </Stack>
  );
};

export default ApiFailureError;
